<div class="d-block">
    @if(selectorReady) {
    <select
        #languageSelect
        (change)="changeLanguage($event)"
        class="custom-select-sm language-selector"
        id="language-selector"
        [attr.aria-label]="
            'LANGUAGE-SELECTOR_SELECTOR-NAME_ALT_TEXT' | translate
        "
    >
        <option
            *ngFor="let language of languages | keyvalue"
            [value]="language.key"
            [innerHtml]="language.value.name"
            [selected]="language.key === selectorLanguage"
        ></option>
    </select>
    }
</div>
